import { ErrorMessage } from '@com-delta-omnichannel/aura';

export interface AEMFeatureFlags<T> {
  flags: T;
}

export interface DisplayProperties {
  disabled: boolean;
  loaded: boolean;
  error?: ErrorMessage;
}

export interface UserSession {
  enrollmentDate: string;
  firstName: string;
  is360Tier: boolean;
  isAbove18: boolean;
  lastName: string;
  loggedIn: boolean;
  medallionMbrInd: string;
  medallionMemberDesc?: string;
  membershipLevel: string;
  middleName: string;
  millionMiler: boolean;
  millionMilerTier?: string;
  skyPriority: boolean;
  skymilesMember: boolean;
  smBalance: string;
  smNumber: string;
  countryCode: string;
  hasPhone: boolean;
  preferredName: string;
  isSkyClubMember: string;
  skyClubMemberType?: string;
  skyClubMembershipDiscontinueDate?: string;
  cobrandCardtypeList: string;
  cobrandCardtypeAffiliationIdList: string;
  cobrandCardtypeDescList: string;
  cobrandCardtypeSkyclubEligibleList: string;
  email: string;
  prefix?: string;
}

export interface ApplyStyles {
  targetClass: string[];
  rules: { [key: string]: string };
}
